export enum JobGroupBy {
    None = 'None',
    Job = 'Job',
}
